import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, UrlSegment, CanLoad } from '@angular/router';
import { Observable } from 'rxjs';

import { UserPermissionsService } from '../services/user-permissions.service';
import { ToasterService } from '../modules/ui-components/toaster';

@Injectable({
  providedIn: 'root'
})
export class PermissionAccountingGuard implements CanActivate, CanLoad {

  constructor(
    private router: Router,
    private userPermissionsService: UserPermissionsService,
    private toasterService: ToasterService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.userPermissionsService.canViewAccounting();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {

    if (!this.userPermissionsService.canViewAccounting()) {
      // this.toasterService.notify({
      //   type: 'error',
      //   message: 'Looks like you have no access to accounting documents. Get in touch with your workspace administrator if you want to get access.'
      // });
      this.router.navigate(['/no-access', {appName: 'accounting'}]);
      return false;
    }

    return this.userPermissionsService.canViewAccounting();
  }
}
